import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import AppNavigate from '../../../components/reusable/app-navigate/AppNavigate';
import { usePullRefreshInvalidateTags } from '../../../hooks/usePullRefreshInvalidateTags';
import { exercisesApi } from '../../../redux/api/exercisesAPI';
import { trainingsApi } from '../../../redux/api/trainingsAPI';
import { EXERCISE_PAGES, TRAININGS } from '../../../redux/constants';
import { Paths } from '../../../shared/paths';
import { useStyles } from './Statistics.styles';
import StatisticsCalendar from './statistics-calendar/StatisticsCalendar';
import StatisticsOverview from './statistics-overview/StatisticsOverview';

const Statistics = () => {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { t, i18n } = useTranslation();
  const { onRefresh } = usePullRefreshInvalidateTags([
    {
      apiSlice: trainingsApi,
      tags: [
        TRAININGS.TRAININGS_FOR_ANALYTIC,
        TRAININGS.TRAININGS_BY_PERIOD,
        TRAININGS.EXERCISES,
      ],
    },
    {
      apiSlice: exercisesApi,
      tags: [EXERCISE_PAGES.AVAILABLE],
    },
  ]);

  const tabsConfig = useMemo(
    () => [
      {
        label: t('statistics.calendar'),
        path: Paths.statistics.toCalendar,
      },
      {
        label: t('statistics.overview'),
        path: Paths.statistics.toOverview,
      },
    ],
    [i18n.language, t],
  );

  return (
    <PageContainer
      title={t('statistics.statistics')}
      description={t('statistics.statisticsDescription')}
      onRefresh={onRefresh}>
      <div className={classes.statisticsWrapper}>
        <AppTabs config={tabsConfig} />
        <div className={classes.tabsContent}>
          <Routes>
            <Route
              path={Paths.statistics.calendar}
              element={<StatisticsCalendar />}
            />
            <Route
              path={Paths.statistics.overview}
              element={<StatisticsOverview />}
            />
            <Route
              path={'*'}
              element={<AppNavigate to={Paths.statistics.toCalendar} replace />}
            />
          </Routes>
        </div>
      </div>
    </PageContainer>
  );
};

export default Statistics;
